/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AnalyzeCsvRequest } from '../models/AnalyzeCsvRequest';
import type { AnalyzeCsvResponse } from '../models/AnalyzeCsvResponse';
import type { QuestionareCsvRequest } from '../models/QuestionareCsvRequest';
import type { QuestionareCsvResponse } from '../models/QuestionareCsvResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SmartAnalyzeService {

    /**
     * Provisions a project using the uploaded CSV file and information.
     * @param requestBody The request to create a project.
     * @returns AnalyzeCsvResponse OK
     * @throws ApiError
     */
    public static analyzeCsv(
        requestBody?: AnalyzeCsvRequest,
    ): CancelablePromise<AnalyzeCsvResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/smartAnalyze/analyzeCsv',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Provisions a project using the uploaded CSV file and information.
     * @param requestBody The request to create a project.
     * @returns QuestionareCsvResponse OK
     * @throws ApiError
     */
    public static questionareCsv(
        requestBody?: QuestionareCsvRequest,
    ): CancelablePromise<QuestionareCsvResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/smartAnalyze/questionareCsv',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

}
